/** 
 * Diese Datei enthält die IP-Adresse und den Port vom Server
 * Verbindung zur API
 */

//// Server
export const SERVER_IP = 'https://knit.bvia.online';
export const API_PORT = 5000;

//// localhost
//export const SERVER_IP = 'http://localhost';
//export const API_PORT = 5002;

export const url_root = `${SERVER_IP}:${API_PORT}/api`;